"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMessagesForLocale;

var _locale = require("./locale");

function getMessagesForLocale(translations) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _locale.getLocale)();
  return translations[(0, _locale.getIsoLocale)(locale)];
}